import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { AccessEnums } from "../../constants/accessEnum";
import BlockNumbersTable from "../../components/panel/block-numbers/BlockNumbersTable";
import { useCanAccess } from "../../hooks/canAccess";
import { IBlockNumberSchema } from "../../services/Schemas/BlockNumber";
import CreateblockNumbersModal from "../../components/panel/block-numbers/CreateblockNumbersModal";

export default function BlockNumbersPage() {
  const [reload, setReload] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [blockNumber, setBlockNumber] = useState<Partial<IBlockNumberSchema> | undefined>(
    undefined
  );

  const onClose = (payload: boolean) => {
    setOpenModal(payload);
    setBlockNumber(undefined);
  };

  const { can } = useCanAccess();
  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                شماره های بلاک شده
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                لیست شماره های بلاک شده
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <Button
                variant="contained"
                disabled={!can(AccessEnums.AdminBlockNumbersCreate)}
                onClick={() => setOpenModal(true)}
              >
                ایجاد شماره
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <BlockNumbersTable
          reload={reload}
          setReload={setReload}
          setOpenModal={setOpenModal}
          setBlockNumber={setBlockNumber}
        />
        <CreateblockNumbersModal
          onClose={onClose}
          handleReload={() => setReload(!reload)}
          open={openModal}
          blockNumber={blockNumber}
        />
      </Stack>
    </>
  );
}
